<script lang="ts" setup>
import { useStore } from 'vuex';
import { computed } from 'vue';
import type { TFeedbackQuestion, TFeedbackStore, TFeedbackQuestionOption } from '../types';
import FeedbackSelectOptionItem from './FeedbackSelectOptionItem.vue';
import { MUTATION_TYPES } from '../store/storeTypes';
import { MODULE_NAME } from '../constants';
import { useFeedback } from '../composable/useFeedback';
type Props = {
  question: TFeedbackQuestion;
};
const { getResultByQuestion, onNext, onGoBack } = useFeedback();
const result = computed(() => {
  return getResultByQuestion(question.id);
});
const store = useStore<{ state: { feedback: TFeedbackStore } }>();
const { question } = defineProps<Props>();
const onClick = (item: TFeedbackQuestionOption) => {
  let answer: any = item;
  if (item.key === result.value?.answer?.key) {
    answer = null;
  }
  store.commit(`${MODULE_NAME}/${MUTATION_TYPES.UPDATE_RESULT}`, {
    questionId: question.id,
    questionType: question.type,
    answer,
  });
  if (!answer) {
    return onGoBack();
  }
  onNext(question);
};
</script>

<template>
  <div class="w-full flex justify-between">
    <FeedbackSelectOptionItem
      @click-star="onClick(item)"
      :active="result?.answer?.key === item.key"
      :item="item"
      v-for="item in question?.options"
      :key="item.key" />
  </div>
</template>
